<template>
  <div class="container">
    <Header></Header>
    <div class="banner">
      <img src="../assets/images/img-hero-image-step123@2x.png" alt="">
    </div>
    <div class="main-content">
      <div class="icon"><img src="../assets/images/icon-payment-error@2x.png" alt=""></div>
      <h1 v-text="$t('msg.errorMsg')"></h1>
      <div class="btn" v-text="$t('msg.errorBtn')" @click="back"></div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'success',
  components: {
    Header,
    Footer,
  },
  methods: {
    back(){
      this.$router.push({ path:'/payment' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.banner{height: 300px;}
.banner img{width: 100%;height: 100%;}
.icon{text-align: center;margin-top: 60px;}
.icon img{width: 100px;height: 100px;margin: 0 auto;}
.main-content h1{font-size: 30px;font-weight: bold;color: #2D354D;text-align: center;margin: 30px 0;}
.btn{width: 600px;height: 50px;line-height: 50px;text-align: center;background: #910000;color: #fff;border-radius: 4px;margin: 0 auto 100px;font-size: 20px;font-weight: bold;cursor: pointer;}

@media screen and (max-width: 640px) {
  .banner{height: 200px;}
  .icon img{width: 70px;height: 70px;}
  .main-content h1{width: 70%;margin: 30px auto 0;font-size: 22px;}
  .btn{width: 70%;margin: 30px auto 100px;}
}
</style>



// WEBPACK FOOTER //
// src/views/Error.vue